import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageCircle, Award, Zap, UserPlus } from 'lucide-react';

/**
 * QuickActionsWidget — 4 one-tap actions to reduce friction for new users.
 * Start a Conversation, View Badges, Try a Challenge, Invite a Friend.
 */
const ACTIONS = [
  { icon: MessageCircle, label: 'Start Conversation', path: '/conversations', color: 'from-blue-500 to-indigo-600' },
  { icon: Award, label: 'View Badges', path: '/badges', color: 'from-purple-500 to-violet-600' },
  { icon: Zap, label: 'Try a Challenge', path: '/friend-challenges', color: 'from-orange-500 to-red-500' },
  { icon: UserPlus, label: 'Invite a Friend', path: '/rewards', color: 'from-emerald-500 to-teal-600' },
];

const QuickActionsWidget = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 mb-4" data-testid="quick-actions-widget">
      <h3 className="text-sm font-bold text-gray-800 mb-3">Quick Actions</h3>
      <div className="grid grid-cols-2 gap-2">
        {ACTIONS.map(action => (
          <button
            key={action.path}
            onClick={() => navigate(action.path)}
            className="flex items-center gap-2.5 p-3 rounded-xl hover:shadow-md transition-all group text-left"
            style={{ background: 'linear-gradient(135deg, #f9fafb, #f3f4f6)' }}
            data-testid={`quick-action-${action.label.toLowerCase().replace(/\s+/g, '-')}`}
          >
            <div className={`w-9 h-9 rounded-lg bg-gradient-to-br ${action.color} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}>
              <action.icon size={18} className="text-white" />
            </div>
            <span className="text-xs font-semibold text-gray-700 leading-tight">{action.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActionsWidget;
